const optimizeAppointments = async ({ date, teamId }) => {
  console.log(date);
  console.log(teamId);
};

export default optimizeAppointments;
